export default "__VITE_ASSET__Dyxr6JTo__"